var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4868 14.14L13.4218 10.444C13.2296 10.2693 12.9771 10.1762 12.7176 10.1842C12.4581 10.1922 12.2118 10.3008 12.0308 10.487L9.63779 12.948C9.06179 12.838 7.90379 12.477 6.71179 11.288C5.51979 10.095 5.15879 8.934 5.05179 8.362L7.51079 5.968C7.69721 5.78712 7.80593 5.54082 7.81396 5.2812C7.82198 5.02159 7.72868 4.76904 7.55379 4.57699L3.85879 0.512995C3.68384 0.320352 3.44067 0.203499 3.18095 0.187255C2.92122 0.17101 2.66539 0.256653 2.46779 0.425995L0.297794 2.28699C0.124905 2.46051 0.0217132 2.69145 0.00779368 2.93599C-0.00720632 3.18599 -0.293206 9.108 4.29879 13.702C8.30479 17.707 13.3228 18 14.7048 18C14.9068 18 15.0308 17.994 15.0638 17.992C15.3083 17.9783 15.5391 17.8747 15.7118 17.701L17.5718 15.53C17.7418 15.333 17.8281 15.0774 17.8122 14.8177C17.7963 14.558 17.6795 14.3148 17.4868 14.14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.91d603ba6ff9e359225be1af3142837a.svg";
export { ForwardRef as ReactComponent };